/**
 * area store
 * @description
 * 区域
 */
export default {
  state: {
    area: []
  },
  getters: {
    getArea: function(state) {
      return state.area;
    }
  },
  mutations: {
    setArea(state, area) {
      state.area = area;
    }
  },
  actions: {
    setArea({ commit }, area) {
      commit('setArea', area);
    }
  }
};
